import { ENotificationTypes } from '../model/types';

export const IMPORTANT_TYPES: Partial<Record<string, boolean>> = {
	[ENotificationTypes.SOURCE_REJECTED]: true,
	[ENotificationTypes.SOURCE_DISCONNECTED]: false,
	[ENotificationTypes.SOURCE_JOINED]: true,
	[ENotificationTypes.SOURCE_RECIEVED]: false,
	[ENotificationTypes.CAP_ASSIGNED]: false,
	[ENotificationTypes.LINK_UPDATED]: false,
	[ENotificationTypes.CUSTOM]: false,
};
